import PageLayout from "@components/layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { ErrorComponent } from "./components/ErrorComponent";

type ErrorPageProps = {
  errorTitle?: string;
  errorDescription?: string;
};

export function ErrorPage({ errorTitle, errorDescription }: ErrorPageProps) {
  const { t } = useTranslation("common");

  return (
    <PageLayout
      title={errorTitle || t("genericErrorTitle")}
      description={errorDescription || t("genericErrorDescription")}>
      <ErrorComponent title={errorTitle} description={errorDescription} />
    </PageLayout>
  );
}
